import Vue from 'vue'
import App from './App.vue'
import VueRouter from "vue-router"
import store from './vuex/AppStore'
import router from "./router/routers"

import {Image as VanImage, RadioGroup, Radio, Field, CellGroup, Cell, Picker,Popup, Toast} from 'vant';
import 'vant/lib/index.css';

Vue.config.productionTip = false
Vue.use(VueRouter)

Vue.use(VanImage);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Field);
Vue.use(Picker);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(Popup);
Vue.use(Toast);
new Vue({
    render: h => h(App),
    router,
    store

}).$mount('#app')
